<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="card tab2-card">
        <div class="card-header">
          <div class="form-group row">
            <div class="col-xl-3 col-md-3">
              <h5><span [innerHtml]=identificationDataLabel></span></h5>
            </div>
          </div>
        </div>
        <div class="card-body tab2-card">
          <form [formGroup]="accountForm" class="needs-validation" novalidate>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <label>Nume<span>*</span></label>
                <input class="form-control" type="text" formControlName="lastName"
                  [attr.disabled]="!editable? true : null">
                <div *ngIf="accountForm.controls['lastName'].errors" class="text text-danger">
                  Numele este obligatoriu
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Prenume<span>*</span></label>
                <input class="form-control" type="text" formControlName="firstName"
                  [attr.disabled]="!editable ? true : null">
                <div *ngIf="accountForm.controls['firstName'].errors" class="text text-danger">
                  Prenumele este obligatoriu
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Telefon<span>*</span></label>
                <input class="form-control" type="text" formControlName="phoneNumber"
                  [attr.disabled]="!editable ? true : null">
                <div *ngIf="accountForm.controls['phoneNumber'].errors" class="text text-danger">
                  Numarul de telefon este obligatoriu
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Email<span>*</span></label>
                <input class="form-control" type="text" formControlName="email"
                  [attr.disabled]="!editable? true : null">
                <div *ngIf="accountForm.controls['email'].errors" class="text text-danger">
                  Emailul este obligatoriu
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <label>Tip client<span>*</span></label>
                <input class="form-control" formControlName="clientType" [attr.disabled]="!editable? true : null">
              </div>
            </div>
            <!--<div class="form-group row" *ngIf="!isContractChange">
              <div class="col-xl-3 col-md-3">
                <label>Încărcare act de identitate
                  &lt;!&ndash;<a
                    href="https://github.com/posfgit/standard/blob/main/Proces%20de%20validare%20a%20datelor%20s%CC%A6i%20de%20aprobare%20a%20cererilor%20de%20conturi%20v2.pdf">
                    <i class="fa fa-info-circle" aria-hidden="true"></i></a>&ndash;&gt;
                  <span>*</span></label>
                <div *ngIf="!identityDocument && isFormSubmitAttempt" class="text text-danger">
                  Vă rugăm încărcați fișierul
                </div>
              </div>
              <div class="dropzone-custom col-xl-6 col-md-6">
                <div [ngClass]="onDisplayRequiredDocument()" class="dropzone dropzone-primary" appDragDropFileUpload
                  (click)="fileField.click()" (fileDropped)="upload($event)">
                  <div class="dz-message needsclick">
                    <i class="fa fa-cloud-upload"></i>
                    <h4 class="mb-0 f-w-600">Apăsați aici și selectați fișierul sau trage-l cu mouse-ul în aceași
                      zonă.</h4>
                    <br>
                    <h4 class="mb-0 f-w-600">Adăugați un fișier, document pdf sau imagine cu următoarele extensii:
                      .jpeg, .jpg, .png</h4>
                  </div>
                  <input type="file" name="avatars" #fileField (change)="upload($any($event).target.files)" hidden />
                </div>
              </div>
            </div>-->
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <h4>Act de identitate</h4>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-8 col-md-8">
                <span class="font-weight-bold">Fisier</span>
              </div>
              <div class="col-xl-2 col-md-2">
                <span class="font-weight-bold">Dimensiune</span>
              </div>
              <div class="col-xl-2 col-md-2">
                <span class="font-weight-bold">Optiuni</span>
              </div>
            </div>
            <div class="form-group row" *ngIf="identityDocument">
              <div class="col-xl-8 col-md-8">
                <span>{{identityDocument.fileName}}</span>
              </div>
              <div class="col-xl-2 col-md-2">
                <span *ngIf="identityDocument.fileByteSize">{{identityDocument.fileByteSize | fileSize}}</span>
              </div>
              <div class="col-xl-2 col-md-2">
                <a *ngIf="identityDocument.file || identityDocument.fileUrl" class="link pointer"
                  (click)="documentService.downloadDocument(identityDocument)">Descarca</a>
              </div>
            </div>
            <div class="form-group row mt-5">
              <div class="col-xl-3 col-md-3">
                <label [ngClass]="onDisplayRequiredField('citizenshipType')">Cetatenie<span>*</span></label>
                <label class="d-block">
                  <input class="radio_animated" type="radio" name="citizenshipType"
                    [attr.disabled]="!editable? true : null"
                    [checked]="this.accountForm.value.citizenshipType === 'CETATEAN_ROMAN'"
                    (click)="setCitizenshipType('Cetatean roman')">
                  {{romanianCitizen}}
                </label>
                <label class="d-block">
                  <input class="radio_animated" type="radio" name="citizenshipType"
                    [attr.disabled]="!editable? true : null"
                    [checked]="this.accountForm.value.citizenshipType === 'CETATEAN_STRAIN'"
                    (click)="setCitizenshipType('Cetatean strain')">
                  {{foreignCitizen}}
                </label>
              </div>
              <ng-container *ngIf="this.accountForm.get('citizenshipType').value">
                <div class="col-xl-3 col-md-3">
                  <label [ngClass]="onDisplayRequiredField('idType')">Tip act de identitate<span>*</span></label>
                  <label class="d-block" *ngIf="this.accountForm.get('citizenshipType').value === 'CETATEAN_ROMAN'">
                    <input class="radio_animated" type="radio" formControlName="idType" [checked]="this.accountForm.value.idType === cnp &&
                    this.accountForm.get('citizenshipType').value === 'CETATEAN_ROMAN'" [value]="'CNP'" name="idType"
                      [attr.disabled]="!editable? true : null">
                    {{idCard}}
                  </label>
                  <label class="d-block">
                    <input class="radio_animated" formControlName="idType" type="radio"
                      [checked]="this.accountForm.value.idType === 'PASSPORT'" [value]="'PASSPORT'" name="idType"
                      [attr.disabled]="!editable? true : null">
                    {{passport}}
                  </label>
                  <label class="d-block" *ngIf="this.accountForm.get('citizenshipType').value === 'CETATEAN_STRAIN'">
                    <input class="radio_animated" type="radio" formControlName="idType"
                      [checked]="this.accountForm.value.idType ==='OTHER' && this.accountForm.get('citizenshipType').value === 'CETATEAN_STRAIN'"
                      [value]="'OTHER'" name="idType" [attr.disabled]="!editable? true : null">
                    {{residenceCard}}
                  </label>
                </div>
              </ng-container>
            </div>
            <ng-container *ngIf="this.accountForm.value.idType">
              <div class="form-group row">
                <div class="col-xl-3 col-md-3">
                  <label *ngIf="!this.accountForm.get('idType').value">{{cnp}}<span>*</span></label>
                  <label *ngIf="this.accountForm.get('idType').value === cnp">{{cnp}}<span>*</span></label>
                  <label
                    *ngIf="this.accountForm.get('idType').value === 'PASSPORT' || this.accountForm.get('idType').value === 'OTHER'">{{identificationNumber}}
                    <span>*</span></label>
                  <input class="form-control" type="text" formControlName="cnp"
                    [attr.disabled]="!editable? true : null" />
                  <div *ngIf="accountForm.controls['cnp'].errors?.['required']"
                    class="text text-danger">
                    CNP este obligatoriu
                  </div>
                  <div
                    *ngIf="(accountForm.controls['cnp'].errors?.['minlength'] || accountForm.controls['cnp'].errors?.['maxlength'] || accountForm.controls['cnp'].errors?.['pattern'])"
                    class="text text-danger">
                    CNP-ul trebuie sa aiba 13 cifre
                  </div>
                </div>
                <div class="col-xl-3 col-md-3">
                  <label>Serie<span>*</span></label>
                  <input class="form-control" type="text" formControlName="idSeries"
                    [attr.disabled]="!editable? true : null" />
                  <div *ngIf="accountForm.controls['idSeries'].errors" class="text text-danger"
                    class="text text-danger">
                    Seria de buletin este obligatorie
                  </div>
                </div>
                <div class=" col-xl-3 col-md-3">
                  <label>Numar<span>*</span></label>
                  <input class="form-control" type="text" formControlName="idNumber"
                    [attr.disabled]="!editable? true : null" />
                  <div *ngIf="accountForm.controls['idNumber'].errors" class="text text-danger">
                    Codul este obligatoriu
                  </div>
                </div>
                <div class="col-xl-3 col-md-3">
                  <label>Emis de<span>*</span></label>
                  <input class="form-control" type="text" formControlName="idEmitter"
                    [attr.disabled]="!editable? true : null" />
                  <div *ngIf="accountForm.controls['idEmitter'].errors" class="text text-danger">
                    Emitentul este obligatoriu
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-xl-3 col-md-3">
                  <label>Valabil de la<span>*</span></label>
                  <input class="form-control" type="date" formControlName="idValidFrom"
                    [attr.disabled]="!editable? true : null" onkeydown="return false" />
                  <div *ngIf="accountForm.controls['idValidFrom'].errors"
                    class="text text-danger">
                    Data de inceput a valabilitatii este obligatorie
                  </div>
                </div>
                <div class="col-xl- col-md-3">
                  <label>pana la<span>*</span></label>
                  <input class="form-control" type="date" formControlName="idValidTo"
                    [attr.disabled]="!editable? true : null" onkeydown="return false" />
                  <div *ngIf="accountForm.controls['idValidTo'].errors" class="text text-danger">
                    Data de sfarsit a valabilitatii este obligatorie
                  </div>
                </div>
              </div>
            </ng-container>

            <div class="form-group row mt-5">
              <div class="col-xl-3 col-md-3">
                <h4> Adresa de domiciliu</h4>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-3 col-sm-3 mb-0">
                <label>Judet<span>*</span></label>
                <select class="form-control digits" formControlName="county" (change)="onChangeCounty()"
                  [attr.disabled]="!editable? true : null">
                  <option *ngFor="let county of counties" [value]="county.id">
                    {{ county.name }} </option>
                </select>
                <div *ngIf="accountForm.controls['county'].errors" class="text text-danger">
                  Judetul este obligatoriu
                </div>
              </div>
              <div class="col-xl-3 col-sm-3 mb-0">
                <label>Localitate<span>*</span></label>
                <select class="form-control digits" formControlName="city" [attr.disabled]="!editable? true : null">
                  <option *ngFor="let city of cities" [value]="city.id">
                    {{ city.name }} </option>
                </select>
                <div *ngIf="accountForm.controls['city'].errors" class="text text-danger">
                  Orasul este obligatoriu
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Strada<span>*</span></label>
                <input class="form-control" type="text" formControlName="streetName"
                  [attr.disabled]="!editable? true : null" />
                <div *ngIf="accountForm.controls['streetName'].errors" class="text text-danger">
                  Numele strazii este obligatoriu
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Numar<span>*</span></label>
                <input class="form-control" type="text" formControlName="streetNumber"
                  [attr.disabled]="!editable? true : null" />
                <div *ngIf="accountForm.controls['streetNumber'].errors"
                  class="text text-danger">
                  Numarul strazii este obligatoriu
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <label>Cod postal<span>*</span></label>
                <input class="form-control" type="text" formControlName="postalCode"
                  [attr.disabled]="!editable? true : null" />
                <div *ngIf="accountForm.controls['postalCode'].errors" class="text text-danger">
                  Codul postal este obligatoriu
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Bloc</label>
                <input class="form-control" type="text" formControlName="block"
                  [attr.disabled]="!editable? true : null" />
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Etaj</label>
                <input class="form-control" type="text" formControlName="floor"
                  [attr.disabled]="!editable? true : null" />
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Apartament</label>
                <input class="form-control" type="text" formControlName="apartment"
                  [attr.disabled]="!editable? true : null" />
              </div>
            </div>
            <div class="form-group row mt-5">
              <div class="col-xl-3 col-md-3">
                <span class="bold"> Adresa de corespondență</span>
              </div>
              <div class="col-xl-3 col-md-3">
                <label class="d-block" for="chk-ani">
                  <input class="checkbox_animated" id="chk-ani" type="checkbox" (click)="toggleSameAddress()"
                    [checked]="isSameAddress" [attr.disabled]="!editable? true : null">
                  Aceeasi cu adresa domiciliu
                </label>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-3 col-sm-3 mb-0">
                <label>Judet<span>*</span></label>
                <select class="form-control digits" formControlName="correspondenceCounty"
                  (change)="onChangeCountyCorrespondence()" [attr.disabled]="!editable? true : null">
                  <option *ngFor="let county of counties" [value]="county.id">
                    {{ county.name }} </option>
                </select>
                <div *ngIf="accountForm.controls['correspondenceCounty'].errors"
                  class="text text-danger">
                  Judetul adresei de corespondenta este obligatoriu
                </div>
              </div>
              <div class="col-xl-3 col-sm-3 mb-0">
                <label>Localitate<span>*</span></label>
                <select class="form-control digits" formControlName="correspondenceCity"
                  [attr.disabled]="!editable? true : null">
                  <option *ngFor="let city of citiesCorrespondence" [value]="city.id">
                    {{ city.name }} </option>
                </select>
                <div *ngIf="accountForm.controls['correspondenceCity'].errors"
                  class="text text-danger">
                  Orasul adresei de corespondenta este obligatoriu
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Strada<span>*</span></label>
                <input class="form-control" type="text" formControlName="correspondenceStreetName"
                  [attr.disabled]="!editable? true : null" />
                <div *ngIf="accountForm.controls['correspondenceStreetName'].errors"
                  class="text text-danger">
                  Numele strazii adresei de corespondenta este obligatoriu
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Numar<span>*</span></label>
                <input class="form-control" formControlName="correspondenceStreetNumber" type="text"
                  [attr.disabled]="!editable? true : null" />
                <div *ngIf="accountForm.controls['correspondenceStreetNumber'].errors"
                  class="text text-danger">
                  Numarul strazii al adresei de corespondenta este obligatoriu
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <label>Cod postal<span>*</span></label>
                <input class="form-control" type="text" formControlName="correspondencePostalCode"
                  [attr.disabled]="!editable? true : null" />
                <div *ngIf="accountForm.controls['correspondencePostalCode'].errors"
                  class="text text-danger">
                  Codul postal al adresei de corespondenta este obligatoriu
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Bloc</label>
                <input class="form-control" type="text" formControlName="correspondenceBlock"
                  [attr.disabled]="!editable? true : null" />
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Etaj</label>
                <input class="form-control" type="text" formControlName="correspondenceFloor"
                  [attr.disabled]="!editable? true : null" />
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Apartament</label>
                <input class="form-control" type="text" formControlName="correspondenceApartment"
                  [attr.disabled]="!editable? true : null" />
              </div>
            </div>

            <div class="form-group row mt-5">
              <div class="col-xl-3 col-md-3">
                <h4 class="d-block" for="ee-client">
                  <input id="ee-client" type="checkbox" [attr.disabled]="!editable? true : null"
                    [checked]="this.accountForm.value.isElectricalEnergyClient"
                    formControlName="isElectricalEnergyClient" (change)="setIsElectricalEnergyClient()">
                  Client energie electrica
                </h4>
              </div>
            </div>
            <ng-container *ngIf="!!this.accountForm.value.isElectricalEnergyClient">
              <div class="ml-1">
                <div class="form-group row">
                  <div class="col-xl-3 col-md-3">
                    <label>{{isUninterruptibleLabel}}<span>*</span></label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" name="uninterrupted-customer"
                        [disabled]="!this.editable || !this.accountForm.value.isElectricalEnergyClient"
                        [checked]="this.userDetails.isUninterruptible" (click)="setIsUninterruptible(true)">
                      {{yes}}
                    </label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" name="uninterrupted-customer"
                        [disabled]="!this.editable || !this.accountForm.value.isElectricalEnergyClient"
                        [checked]="!this.userDetails.isUninterruptible" (click)="setIsUninterruptible(false)">
                      {{no}}
                    </label>
                  </div>
                  <div class="col-xl-3 col-md-3">
                    <label>{{isVulnerableLabel}}<span>*</span>
                    </label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" name="electric-vulnerable-customer"
                        [attr.disabled]="!this.editable || !this.accountForm.value.isElectricalEnergyClient? true : null"
                        [checked]="this.userDetails.isVulnerable" (click)="setIsVulnerable(true)">
                      {{yes}}
                    </label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" name="electric-vulnerable-customer"
                        [attr.disabled]="!this.editable || !this.accountForm.value.isElectricalEnergyClient? true : null"
                        [checked]="!this.userDetails.isVulnerable" (click)="setIsVulnerable(false)">
                      NU
                    </label>
                  </div>
                  <div class="col-xl-3 col-md-3">
                    <label>{{isProsumerLabel}}<span>*</span></label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" name="prosumer" [checked]="this.userDetails.isProsumer"
                        [disabled]="!this.editable || !this.accountForm.value.isElectricalEnergyClient"
                        (click)="setIsProsumer(true)">
                      {{yes}}
                    </label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" name="prosumer"
                        [checked]="!this.userDetails.isProsumer"
                        [disabled]="!this.editable || !this.accountForm.value.isElectricalEnergyClient"
                        (click)="setIsProsumer(false)">
                      NU
                    </label>
                  </div>

                  <div class="col-xl-3 col-md-3">
                    <label>{{isAutoSupplierLabel}}</label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" name="isAutoSupplier"
                        [checked]="accountForm.value.isAutoSupplier === true" [attr.disabled]="!editable ? true : null"
                        (click)="setAutoSupplier(true)">
                      {{yes}}
                    </label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" name="isAutoSupplier"
                        [checked]="accountForm.value.isAutoSupplier === false" [attr.disabled]="!editable ? true : null"
                        (click)="setAutoSupplier(false)">
                      {{no}}
                    </label>
                  </div>
                </div>

                <div class="form-group row mt-5">
                  <div class="col-xl-3 col-md-3">
                    <h4>Date agregare</h4>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-xl-3 col-md-3">
                    <label>{{isAgregateLabel}}<span>*</span></label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" name="aggregation"
                        [disabled]="!this.editable || !this.accountForm.value.isElectricalEnergyClient"
                        [checked]="this.accountForm.value.isAggregate" (click)="setIsAggregate(true)">
                      {{yes}}
                    </label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" name="aggregation"
                        [disabled]="!this.editable || !this.accountForm.value.isElectricalEnergyClient"
                        [checked]="!this.accountForm.value.isAggregate" (click)="setIsAggregate(false)">
                      {{no}}
                    </label>
                  </div>
                  <div class="col-xl-3 col-md-3">
                    <label>Agregatorul este: </label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" name="aggregatorIs"
                        (click)="onAggregatorType('Persoana fizica')" [attr.disabled]="(!this.editable || !this.accountForm.value.isElectricalEnergyClient ||
                        !this.accountForm.controls.isAggregate.value)? true : null"
                        [checked]="this.accountForm.value.aggregatorClientType === 'PERSOANA_FIZICA' ">
                      Persoana fizica
                    </label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" name="aggregatorIs"
                        (click)="onAggregatorType('Persoana juridica')" [attr.disabled]="(!this.editable || !this.accountForm.value.isElectricalEnergyClient ||
                        !this.accountForm.controls.isAggregate.value)? true : null"
                        [checked]="this.accountForm.value.aggregatorClientType === 'PERSOANA_JURIDICA' ">
                      Persoana juridica
                    </label>
                  </div>
                </div>
                <ng-container *ngIf="this.accountForm.value.isAggregate">
                  <div class="form-group row" *ngIf="this.accountForm.value.aggregatorClientType === 'PERSOANA_FIZICA'">
                    <div class="col-xl-3 col-md-3">
                      <label>Nume<span>*</span></label>
                      <input class="form-control" type="text" formControlName="aggregationPersonName"
                        [attr.disabled]="!editable? true : null">
                      <div *ngIf="accountForm.controls['aggregationPersonName'].errors"
                        class="text text-danger">
                        Numele este obligatoriu
                      </div>
                    </div>
                    <div class="col-xl-3 col-md-3">
                      <label>Prenume<span>*</span></label>
                      <input class="form-control" type="text" formControlName="aggregationPersonSurname"
                        [attr.disabled]="!editable? true : null">
                      <div *ngIf="accountForm.controls['aggregationPersonSurname'].errors"
                        class="text text-danger">
                        Prenumele este obligatoriu
                      </div>
                    </div>
                    <div class="col-xl-3 col-md-3">
                      <label>CNP<span>*</span></label>
                      <input class="form-control" type="text" formControlName="aggregationPersonCnp"
                        [attr.disabled]="!editable? true : null">
                      <div
                        *ngIf="accountForm.controls['aggregationPersonCnp'].errors?.['required']"
                        class="text text-danger">
                        CNP-ul este obligatoriu
                      </div>
                      <div
                        *ngIf="accountForm.controls['aggregationPersonCnp'].errors?.['minlength'] || accountForm.controls['aggregationPersonCnp'].errors?.['maxlength'] || accountForm.controls['aggregationPersonCnp'].errors?.['pattern']"
                        class="text text-danger">
                        CNP-ul trebuie sa aiba 13 cifre
                      </div>
                    </div>
                  </div>
                  <div class="form-group row"
                    *ngIf="this.accountForm.value.aggregatorClientType === 'PERSOANA_JURIDICA'">
                    <div class="col-xl-3 col-md-3">
                      <label>Denumire<span>*</span></label>
                      <input class="form-control" type="text" formControlName="aggregationName"
                        [attr.disabled]="!editable? true : null" />
                      <div *ngIf="accountForm.controls['aggregationName'].errors"
                        class="text text-danger">
                        Denumirea obligatorie
                      </div>
                    </div>
                    <div class="col-xl-3 col-md-3">
                      <label>Forma juridica<span>*</span></label>
                      <input class="form-control" type="text" formControlName="aggregationJuridicalForm"
                        [attr.disabled]="!editable? true : null" />
                      <div *ngIf="accountForm.controls['aggregationJuridicalForm'].errors"
                        class="text text-danger">
                        Forma juridica obligatorie
                      </div>
                    </div>
                    <div class="col-xl-3 col-md-3">
                      <label>CUI<span>*</span></label>
                      <input class="form-control" type="text" formControlName="aggregationCui"
                        [attr.disabled]="!editable? true : null" />
                      <div *ngIf="accountForm.controls['aggregationCui'].errors"
                        class="text text-danger">
                        CUI obligatoriu
                      </div>
                    </div>
                    <div class="col-xl-3 col-md-3">
                      <label>Nr. inregistrare la ONRC<span>*</span></label>
                      <input class="form-control" type="text" formControlName="aggregationOnrcRegistrationNumber"
                        [attr.disabled]="!editable? true : null" />
                      <div
                        *ngIf="accountForm.controls['aggregationOnrcRegistrationNumber'].errors"
                        class="text text-danger">
                        Nr. inregistrare la ONRC obligatoriu
                      </div>
                    </div>
                  </div>
                  <div class="form-group row"
                    *ngIf="this.accountForm.value.aggregatorClientType === 'PERSOANA_JURIDICA'">
                    <div class="col-xl-3 col-md-3">
                      <label>Telefon<span>*</span></label>
                      <input class="form-control" type="text" formControlName="aggregationPhoneNumber"
                        [attr.disabled]="!editable? true : null" />
                      <div *ngIf="accountForm.controls['aggregationPhoneNumber'].errors"
                        class="text text-danger">
                        Telefon obligatoriu
                      </div>
                    </div>
                    <div class="col-xl-3 col-md-3">
                      <label>Mobil<span>*</span></label>
                      <input class="form-control" type="text" formControlName="aggregationMobilePhoneNumber"
                        [attr.disabled]="!editable? true : null" />
                      <div *ngIf="accountForm.controls['aggregationMobilePhoneNumber'].errors"
                        class="text text-danger">
                        Mobil obligatoriu
                      </div>
                    </div>
                    <div class="col-xl-3 col-md-3">
                      <label>Fax<span>*</span></label>
                      <input class="form-control" type="text" formControlName="aggregationFax"
                        [attr.disabled]="!editable? true : null" />
                      <div *ngIf="accountForm.controls['aggregationFax'].errors"
                        class="text text-danger">
                        Fax obligatoriu
                      </div>
                    </div>
                    <div class="col-xl-3 col-md-3">
                      <label>Email<span>*</span></label>
                      <input class="form-control" type="text" formControlName="aggregationEmail"
                        [attr.disabled]="!editable? true : null" />
                      <div *ngIf="accountForm.controls['aggregationEmail'].errors"
                        class="text text-danger">
                        Email obligatoriu
                      </div>
                    </div>
                  </div>
                </ng-container>

                <div class="form-group row mt-5">
                  <div class="col-xl-3 col-md-3">
                    <h4>Date parte responsabila cu echilibrarea</h4>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-xl-3 col-md-3">
                    <label>{{setHasDelegatedPRELabel}}<span>*</span></label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" name="balancingProcessDelegate"
                        [disabled]="!this.accountForm.value.isElectricalEnergyClient || !editable"
                        [checked]="this.accountForm.value.balancingProcessHasDelegatedPRE"
                        (click)="setHasDelegatedPRE(true)" [attr.disabled]="!editable? true : null">
                      {{yes}}
                    </label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" name="balancingProcessDelegate"
                        [disabled]="!this.accountForm.value.isElectricalEnergyClient || !editable"
                        [checked]="!this.accountForm.value.balancingProcessHasDelegatedPRE"
                        (click)="setHasDelegatedPRE(false)">
                      {{no}}
                    </label>
                  </div>
                  <div class="col-xl-3 col-md-3">
                    <label>{{balancingProcessHasOtherPRELabel}}<span>*</span></label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" name="balancingProcessOtherPRE"
                        [disabled]="!this.editable || !this.accountForm.value.isElectricalEnergyClient"
                        [checked]="this.accountForm.value.balancingProcessHasOtherPRE" (click)="setHasOtherPRE(true)">
                      {{yes}}
                    </label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" name="balancingProcessOtherPRE"
                        [disabled]="!this.editable || !this.accountForm.value.isElectricalEnergyClient"
                        [checked]="!this.accountForm.value.balancingProcessHasOtherPRE" (click)="setHasOtherPRE(false)">
                      {{no}}
                    </label>
                  </div>
                  <div class="col-xl-3 col-md-3">
                    <label>PRE-ul este:</label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" name="preType"
                        (change)="onBalancingProcessPreType('Persoana fizica')"
                        [attr.disabled]="!this.editable || !this.accountForm.value.isElectricalEnergyClient ||
                      !(this.accountForm.value.balancingProcessHasOtherPRE || this.accountForm.value.balancingProcessHasDelegatedPRE)? true : null"
                        [checked]="this.accountForm.value.balancingProcessPreType === 'PERSOANA_FIZICA'">
                      Persoana fizica
                    </label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" name="preType"
                        (change)="onBalancingProcessPreType('Persoana juridica')"
                        [attr.disabled]="!this.editable || !this.accountForm.value.isElectricalEnergyClient ||
                      !(this.accountForm.value.balancingProcessHasOtherPRE || this.accountForm.value.balancingProcessHasDelegatedPRE)? true : null"
                        [checked]="this.accountForm.value.balancingProcessPreType === 'PERSOANA_JURIDICA'">
                      Persoana juridica
                    </label>
                  </div>
                </div>
                <div class="form-group row"
                  *ngIf="this.accountForm.value.balancingProcessPreType === 'PERSOANA_FIZICA'">
                  <div class="col-xl-3 col-md-3">
                    <label>Nume<span>*</span></label>
                    <input class="form-control" type="text" formControlName="balancingProcessPersonName"
                      [attr.disabled]="!editable? true : null">
                    <div *ngIf="accountForm.controls['balancingProcessPersonName'].errors"
                      class="text text-danger">
                      Nume obligatoriu
                    </div>
                  </div>
                  <div class="col-xl-3 col-md-3">
                    <label>Prenume<span>*</span></label>
                    <input class="form-control" type="text" formControlName="balancingProcessPersonSurname"
                      [attr.disabled]="!editable? true : null">
                    <div *ngIf="accountForm.controls['balancingProcessPersonSurname'].errors"
                      class="text text-danger">
                      Prenume obligatoriu
                    </div>
                  </div>
                  <div class="col-xl-3 col-md-3">
                    <label>CNP<span>*</span></label>
                    <input class="form-control" type="text" formControlName="balancingProcessPersonCnp"
                      [attr.disabled]="!editable? true : null">
                    <div *ngIf="accountForm.controls['balancingProcessPersonCnp'].errors"
                      class="text text-danger">
                      CNP obligatoriu
                    </div>
                    <div
                      *ngIf="accountForm.controls['balancingProcessPersonCnp'].errors?.['minlength'] || accountForm.controls['balancingProcessPersonCnp'].errors?.['maxlength'] || accountForm.controls['balancingProcessPersonCnp'].errors?.['pattern']"
                      class="text text-danger">
                      CNP-ul trebuie sa aiba 13 cifre
                    </div>
                  </div>
                </div>
                <div class="form-group row"
                  *ngIf="this.accountForm.value.balancingProcessPreType === 'PERSOANA_JURIDICA'">
                  <div class="col-xl-3 col-md-3">
                    <label>Denumire<span>*</span></label>
                    <input class="form-control" type="text" formControlName="balancingProcessName"
                      [attr.disabled]="!editable? true : null" />
                    <div *ngIf="accountForm.controls['balancingProcessName'].errors"
                      class="text text-danger">
                      Denumire obligatorie
                    </div>
                  </div>
                  <div class="col-xl-3 col-md-3">
                    <label>Forma juridica<span>*</span></label>
                    <input class="form-control" type="text" formControlName="balancingProcessJuridicalForm"
                      [attr.disabled]="!editable? true : null" />
                    <div *ngIf="accountForm.controls['balancingProcessJuridicalForm'].errors"
                      class="text text-danger">
                      Forma juridica obligatorie
                    </div>
                  </div>
                  <div class="col-xl-3 col-md-3">
                    <label>CUI<span>*</span></label>
                    <input class="form-control" type="text" formControlName="balancingProcessCui"
                      [attr.disabled]="!editable? true : null" />
                    <div *ngIf="accountForm.controls['balancingProcessCui'].errors"
                      class="text text-danger">
                      CUI obligatoriu
                    </div>
                  </div>
                  <div class="col-xl-3 col-md-3">
                    <label>Nr. inregistrare la ONRC<span>*</span></label>
                    <input class="form-control" type="text" formControlName="balancingProcessRegistrationNumber"
                      [attr.disabled]="!editable? true : null" />
                    <div
                      *ngIf="accountForm.controls['balancingProcessRegistrationNumber'].errors"
                      class="text text-danger">
                      Nr. inregistrare la ONRC obligatoriu
                    </div>
                  </div>
                </div>
                <div class="form-group row"
                  *ngIf="this.accountForm.value.balancingProcessPreType === 'PERSOANA_JURIDICA'">
                  <div class="col-xl-3 col-md-3">
                    <label>Telefon<span>*</span></label>
                    <input class="form-control" type="text" formControlName="balancingProcessPhoneNumber"
                      [attr.disabled]="!editable? true : null" />
                    <div *ngIf="accountForm.controls['balancingProcessPhoneNumber'].errors"
                      class="text text-danger">
                      Telefon obligatoriu
                    </div>
                  </div>
                  <div class="col-xl-3 col-md-3">
                    <label>Mobil<span>*</span></label>
                    <input class="form-control" type="text" formControlName="balancingProcessMobilePhoneNumber"
                      [attr.disabled]="!editable? true : null" />
                    <div *ngIf="accountForm.controls['balancingProcessMobilePhoneNumber'].errors"
                      class="text text-danger">
                      Mobil obligatoriu
                    </div>
                  </div>
                  <div class="col-xl-3 col-md-3">
                    <label>Fax<span>*</span></label>
                    <input class="form-control" type="text" formControlName="balancingProcessFax"
                      [attr.disabled]="!editable? true : null" />
                    <div *ngIf="accountForm.controls['balancingProcessFax'].errors"
                      class="text text-danger">
                      Fax obligatoriu
                    </div>
                  </div>
                  <div class="col-xl-3 col-md-3">
                    <label>Email<span>*</span></label>
                    <input class="form-control" type="text" formControlName="balancingProcessEmail"
                      [attr.disabled]="!editable? true : null" />
                    <div *ngIf="accountForm.controls['balancingProcessEmail'].errors"
                      class="text text-danger">
                      Email obligatoriu
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <div class="form-group row mt-5">
              <div class="col-xl-3 col-md-3">
                <h4 class="d-block" for="ng-client">
                  <input id="ng-client" type="checkbox" [attr.disabled]="!this.editable? true:null"
                    [checked]="this.accountForm.value.isNaturalGasClient" formControlName="isNaturalGasClient"
                    (change)="setIsNaturalGasClient()">
                  Client gaze naturale
                </h4>
              </div>
            </div>
            <ng-container *ngIf="!!this.accountForm.value.isNaturalGasClient">
              <div class="ml-1">
                <div class="form-group row">
                  <div class="col-xl-3 col-md-3">
                    <label>{{isVulnerableLabel}}<span>*</span></label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" name="gas-vulnerable-customer"
                        [checked]="this.userDetails.isVulnerable" (click)="setIsVulnerable(true)"
                        [disabled]="!this.editable || !this.accountForm.value.isNaturalGasClient">
                      {{yes}}
                    </label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" name="gas-vulnerable-customer"
                        [checked]="!this.userDetails.isVulnerable" (click)="setIsVulnerable(false)"
                        [disabled]="!this.editable || !this.accountForm.value.isNaturalGasClient">
                      {{no}}
                    </label>
                  </div>
                </div>
              </div>
            </ng-container>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
